import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "is-flex is-justify-content-space-between is-align-items-center" }
const _hoisted_2 = { class: "list-table-container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "has-text-centered mt-4 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_breadcrumb_item = _resolveComponent("b-breadcrumb-item")!
  const _component_b_breadcrumb = _resolveComponent("b-breadcrumb")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_table_column = _resolveComponent("b-table-column")!
  const _component_b_table = _resolveComponent("b-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_b_breadcrumb, {
        size: "is-large",
        separator: "has-succeeds-separator",
        "aria-label": "breadcrumbs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_breadcrumb_item, { active: "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('secrets.title')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_b_button, {
        type: "is-primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'secret-add' })))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('secrets.addNew')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_b_table, {
        data: _ctx.rows,
        striped: "",
        loading: _ctx.loading,
        onClick: _ctx.handleRowClick,
        "sort-icon": "menu-up",
        "default-sort": "name",
        "default-sort-direction": "asc"
      }, {
        empty: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('secrets.noSecrets')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_b_table_column, {
            field: "name",
            sortable: "",
            label: _ctx.$t('secrets.name')
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(props.row.name), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "usageCount",
            sortable: "",
            label: _ctx.$t('secrets.usageCount')
          }, {
            default: _withCtx((props) => [
              _createTextVNode(_toDisplayString(props.row.usageCount || 0), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "updatedAt",
            sortable: "",
            label: _ctx.$t('secrets.lastUpdated')
          }, {
            default: _withCtx((props) => [
              (props.row.updatedAt)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$d(new Date(props.row.updatedAt), 'short')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, "—"))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            field: "accessedAt",
            sortable: "",
            label: _ctx.$t('secrets.lastAccessed')
          }, {
            default: _withCtx((props) => [
              (props.row.accessedAt)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$d(new Date(props.row.accessedAt), 'short')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, "—"))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_b_table_column, {
            label: _ctx.$t('global.action')
          }, {
            default: _withCtx((props) => [
              _createVNode(_component_b_button, {
                type: "is-danger",
                size: "is-small",
                "icon-left": "delete",
                title: _ctx.$t('global.delete'),
                "aria-label": "delete",
                onClick: _withModifiers(($event: any) => (_ctx.confirmRemove(props.row)), ["stop"])
              }, null, 8, ["title", "onClick"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data", "loading", "onClick"])
    ])
  ]))
}